import React from "react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/content";
const struggles = ["Creating worksheets at midnight.", "Building certificates from scratch.", "Trying to organize lessons.", "Searching for ideas for student activities."];
export function Creator() {
  return <Section tone="blush" wide data-id="element-112" data-mp="1o6xbzmt4vf5f">
      <SectionHeading kicker="Meet your creator" data-id="element-113" data-mp="2bymbpo8ab5we">Hi, I'm Emily Carter.</SectionHeading>

      <div className="mt-10 grid items-start gap-8 md:grid-cols-[0.85fr_1.15fr] md:gap-12" data-id="element-114" data-mp="2g0zh2bj4d1sn">
        <img src={images.creator} alt="Emily Carter, nail educator and creator of Nail Course In A Box™, at her desk" className="mx-auto w-full max-w-md rounded-3xl object-cover shadow-[0_24px_50px_-24px_rgba(43,27,34,0.5)] md:sticky md:top-8" data-id="element-115" data-mp="220yf0sr4bobl" />
        <div className="space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-116" data-mp="qnvwhs5gkoos">
          <p data-id="element-117" data-mp="vlxj2n23f650">
            For years, I watched talented nail artists struggle with something that had nothing to do with their
            technical ability.
          </p>
          <p className="font-semibold text-ink" data-id="element-118" data-mp="2tfl5dqx2ygnz">
            They knew nails. They knew their techniques. They knew how to create beautiful work.
          </p>
          <p data-id="element-119" data-mp="32fhq5hgcmvdr">But when it came time to teach, everything became harder. They were:</p>
          <ul className="space-y-2 border-l-2 border-berry pl-4" data-id="element-120" data-mp="32hkpis3e60v5">
            {struggles.map(s => <li key={s} className="text-ink" data-id="element-121" data-mp="3cde045xjvkaa">
                {s}
              </li>)}
          </ul>
          <p data-id="element-122" data-mp="3q4j0ja8qsglo">And opening Canva over and over again to create another document from a blank page.</p>
          <p className="font-serif text-[22px] font-bold leading-snug text-berry" data-id="element-123" data-mp="3l5zcn4al8uqo">
            Being a great nail artist and being a great nail educator are two different skills.
          </p>
          <p data-id="element-124" data-mp="3v45fpp84s6x4">
            That's why I created Nail Course In A Box™. I didn't want to create another course that tells you more
            theory. I wanted to create the tools I wish every nail educator had before teaching their next class — a
            system you can open, customize and use.
          </p>
          <p className="font-semibold text-ink" data-id="element-125" data-mp="fzdfqc2gscl2">You bring your expertise. I give you the structure.</p>
          <p data-id="element-126" data-mp="kqvhv3g84j7m">
            And together, you can create an educational experience that looks as professional as the work you already
            create with your hands. I'm so excited for you to use it.
          </p>
          <div className="pt-2" data-id="element-127" data-mp="tq8v877gxrxm">
            <p className="font-serif text-[28px] italic text-ink" data-id="element-128" data-mp="ttd61nffvlx9">— Emily Carter</p>
            <p className="text-[14px] text-muted" data-id="element-129" data-mp="yqwhygonzmm1">Nail Educator & Creator of Nail Course In A Box™</p>
          </div>
        </div>
      </div>

      <CTAButton label="I'm ready to teach with a system" data-id="element-130" data-mp="30hzu5ae7d98p" />
    </Section>;
}